import React from 'react';
import { Card, Button } from 'react-bootstrap';
import '../css sheets/home.css'

function Home() {
  return (
  <div>
    <img src="transparent_profile.png" className='home-image'></img>
    <h1 className="home-header">ANDREW S. THOMAS</h1>
    <h1 className="home-header">FULLSTACK DEVELOPER</h1>
    
    
  </div>
  );
}

export default Home;
